
import {
  Box,
  Grid,
  Stack,
  Typography,
  Container,
  Chip,
  Link as MuiLink,
} from "@mui/material";
import { useState, useCallback, useEffect, useRef } from "react";
import { fetchImage } from "src/utils/fetchImage";
import { useSelector, useDispatch } from "react-redux";
import { getReservationHistoryByCustomerId } from "src/redux/slices/reservation";
import { convertTimeFormat } from "src/utils/formatTime";
import LoadingScreen from "src/components/loading-screen/LoadingScreen";
import EmptyContent from "src/components/empty-content/EmptyContent";
import Image from "src/components/image/Image";
import ReservationModal from "./ReservationModal";

const ReservationHistory = () => {
  const { reservationHistory, isLoading } = useSelector(
    (state) => state.reservation
  );

  const { user } = useSelector((state) => state.login);

  const dispatch = useDispatch();
  const [openConfirm, setOpenConfirm] = useState(false);
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };


  const getReservation = useCallback(async () => {
    try {
      await dispatch(getReservationHistoryByCustomerId(user?.id))
    } catch (error) { }
  }, [reservationHistory]);

  useEffect(() => {
    getReservation();
  }, []);

  const [imageURLs, setImageURLs] = useState([]);
  const [detail, setDetail] = useState("");

  useEffect(() => {
    const fetchImagesForOrders = async () => {
      if (reservationHistory && reservationHistory.length > 0) {
        const urls = await Promise.all(
          reservationHistory.map(async (elem) => {
            try {
              const res = await fetchImage(elem.venueId.photoURL);
              return res;
            } catch (error) {
              console.error("Error fetching data:", error);
              return null;
            }
          })
        );
        setImageURLs(urls);
      }
    };

    fetchImagesForOrders();
  }, [reservationHistory]);

  const getChipStyle = (status) => {
    switch (status) {
      case "pending":
        return {
          backgroundColor: "rgba(0, 184, 217, 0.16)",
          color: "#006C9C",
        };
      case "cancelled":
        return {
          backgroundColor: "rgba(255, 86, 48, 0.16)",
          color: "#B71D18",
        };
      case "completed":
        return {
          backgroundColor: "rgba(54, 179, 126, 0.16)",
          color: "#1B806A",
        };
      case "checkin":
        return {
          backgroundColor: "rgba(255, 171, 0, 0.16)",
          color: "#B76E00",
        };
    }
  };

  const capitilizeText = (state) => {
    return state == "pending"
      ? "Pending"
      : state == "cancelled" ?
        "Cancelled" :
        state == "completed" ?
          "Completed" :
          state == "checkin" ?
            "Check In" : state
  };
  const ReservationDetails = (elem) => {
    setDetail(elem);
    setOpenConfirm(true);
  };


  function formatTimeWithDate(startTime, endTime) {
    const date = new Date(startTime);
    const options = {
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    };
    const formattedDate = date.toLocaleDateString('en-US', options);

    function formatTime(time) {
      const dateObj = new Date(time);
      let hours = dateObj.getUTCHours();
      let minutes = dateObj.getUTCMinutes();
      const ampm = hours >= 12 ? 'pm' : 'am';

      hours = hours % 12 || 12;
      minutes = minutes.toString().padStart(2, '0');

      return `${hours}:${minutes} ${ampm}`;
    }

    return `${formattedDate} ${formatTime(startTime)}`;
  }



  return (
    <>
      <Box
        sx={{
          marginLeft: "35px",
          marginRight: "35px",
          "@media (max-width: 1025px)": {
            marginLeft: "0px",
            marginRight: "0px",
          },
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              marginTop: "120px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              overflow: "hidden",
              "@media (max-width: 899px)": {
                marginTop: "150px",
              },
            }}
          >
            <Stack>
              <Typography variant="h3">Reservation History</Typography>
            </Stack>
          </Box>
          {isLoading ? (
            <LoadingScreen width="100px" height="100px" marginT="0" h="70vh" />
          ) : (
            <>
              <Box>
                {reservationHistory?.length > 0 ? (
                  <Grid container spacing={3} mt={1} mb={5}>
                    {reservationHistory &&
                      reservationHistory?.map((elem, index) => {
                        return (
                          <Grid item xs={12} md={6} key={index}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "row",
                                padding: "10px",
                                border: "1px solid rgba(0, 0, 0, 0.15)",
                                borderRadius: "5px",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                cursor: "pointer",

                                "@media (max-width: 600px)": {
                                  flexDirection: "column",
                                },
                              }}
                            >
                              <Stack
                                onClick={() => ReservationDetails(elem)}
                                sx={{
                                  flexDirection: "row",
                                }}
                              >
                                <Box>
                                  <Image
                                    src={
                                      imageURLs[index]
                                        ? imageURLs[index]
                                        : "/assets/placeholder.png"
                                    }
                                    alt={"image"}
                                    sx={{
                                      height: {
                                        xs: "100px",
                                        sm: "90px",
                                        md: "110px",
                                        lg: "120px",
                                      },
                                      width: {
                                        xs: "110px",
                                        sm: "130px",
                                        md: "160px",
                                        lg: "185px",
                                      },
                                      borderRadius: "5px",
                                    }}
                                  />
                                </Box>
                                <Box
                                  sx={{
                                    marginTop: "-4px",
                                    marginLeft: "15px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "24px",
                                      fontWeight: 700,
                                      color: "#F59B34"
                                    }}>
                                    {elem?.venueId?.name}
                                  </Typography>
                                  <Typography sx={{ fontSize: "14px", marginBottom: 0.4 }}>
                                    <span style={{ fontWeight: 600 }}>ID:</span>{" "}
                                    <span style={{ fontWeight: 400, letterSpacing: "0.5px" }}>
                                      {elem?._id.slice(-6)}
                                    </span>
                                  </Typography>

                                  <Box display="flex" gap={1} marginTop={0.4}>
                                    <img
                                      src="/assets/header-tabs/reservationHistory/reserveHistoryCalender.svg"
                                      alt="Calendar"
                                      width={15}
                                      height={15} />
                                    <Typography
                                      variant="span"
                                      sx={{
                                        fontSize: "12px",
                                      }}
                                    >

                                      {formatTimeWithDate(elem?.startTime, elem?.endTime)}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{ display: "flex", marginTop: 1.5 }}
                                  >
                                    <Chip
                                      label={capitilizeText(elem.status)}
                                      sx={{
                                        ...getChipStyle(elem.status),
                                        borderRadius: "10px",
                                        fontWeight: "600",
                                        height: "30px",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </Stack>
                            </Box>
                          </Grid>
                        );
                      })}
                  </Grid>
                ) : (
                  <EmptyContent
                    title="No Reservation"
                    sx={{
                      "& span.MuiBox-root": { height: 160 },
                    }}
                  />
                )}
              </Box>
            </>
          )}
        </Container>
      </Box>
      {openConfirm && (
        <ReservationModal
          width="sm"
          open={openConfirm}
          onClose={handleCloseConfirm}
          detail={detail}
          getReservation={getReservation}
        />
      )}
    </>
  );
};
export default ReservationHistory;